import React from "react";
import { getSearchResult } from "../actions/searchAction";
import { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { audienceListColumns } from "../config/column_fields";

class AudienceListWhatsapp extends Component {
    constructor() {
        super();
        this.state = {
            audienceColumns: []
        };
    }

    componentDidMount() {

    }

    handleDownloadAudienceClick = (row) => {
        console.log("handleDownloadAudienceClick", row);
        let { filePath = '' } = row;
        this.props.downloadAudFile(filePath);
    }

    componentWillMount() {
        let audienceColumns = audienceListColumns.map(row => {
            if(row.accessor === 'downloadAudFile') {
                row.Cell = (row) => {
                    return <button className="btn btn-sm btn-success" onClick={() => this.handleDownloadAudienceClick(row.original)}>Download</button>
                }
            }
            return row;
        });
        this.setState({ audienceColumns: audienceColumns })
        this.props.fetchAudienceList();
    }

    render() {
        return (
            <div className="procurementAddVendor">
                <ReactTable
                    filterable={true}
                    showPagination={true}
                    sortable={true}
                    data={this.props.audienceList}
                    columns={this.state.audienceColumns}
                    defaultSorted={[{ id: "id", desc: true }]}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id])
                            .toLowerCase()
                            .indexOf(filter.value.toLowerCase()) > -1
                    }
                    defaultPageSize={10}
                />
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getSearchResult }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AudienceListWhatsapp);
